import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import AIChatSidebar from "../components/chat/AIChatSidebar";
import PDFViewer from "../components/chat/PDFViewer";

const ChatPage = () => {
  const [searchParams] = useSearchParams();
  const selectedThread = searchParams.get("thread");
  const { isAuthenticated } = useAuth();

  const [pdfState, setPdfState] = useState({
    url: "https://pub-0cb9682969394a979c9d4d12a6aa2bae.r2.dev/pdfs/onebankplc_price_sensitive_2024_null.pdf_20260131121533",
    page: 1,
    filename: "as",
    isOpen: false,
  });

  const handleOpenPdf = (url, page = 1, filename = "Document.pdf") => {
    console.log("ChatPage handleOpenPdf called:", { url, page, filename });
    setPdfState({
      url,
      page,
      filename,
      isOpen: true,
    });
  };

  const handleClosePdf = () => {
    setPdfState((prev) => ({ ...prev, isOpen: false }));
  };

  return (
    <div className="flex flex-col h-full bg-white overflow-hidden">
      {!isAuthenticated ? (
        <div className="flex flex-col items-center justify-center h-full px-4 text-center">
          <h1 className="text-3xl md:text-4xl font-semibold text-gray-900 mb-8">
            Please log in to chat with TraderBro.
          </h1>
        </div>
      ) : (
        <div className="flex-1 flex flex-row gap-2 min-h-0">
          <PDFViewer
            url={pdfState.url}
            page={pdfState.page}
            filename={pdfState.filename}
            isOpen={pdfState.isOpen}
            onClose={handleClosePdf}
            className="flex-1 overflow-hidden"
          />
          <AIChatSidebar
            mode="chat"
            className="flex-1 border-l-0 overflow-hidden"
            placeholder="Ask anything about stocks, markets, or your portfolio..."
            loadHistory={true}
            initialThreadId={selectedThread}
            onOpenPdf={handleOpenPdf}
          />
        </div>
      )}
    </div>
  );
};

export default ChatPage;
